<template>
    <div>
        <label
            class="block text-sm font-medium leading-5 text-gray-700"
            :for="name"
            v-if="label"
        >
            {{ label }}
        </label>
        <textarea
            :id="name"
            :name="name"
            :disabled="disabled"
            class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 mt-1 block w-full sm:text-sm border-gray-300 rounded-md"
            :rows="rows"
            :value="value"
            ref="input"
            v-on="inputListeners"
        />
        <slot />
    </div>
</template>

<script>
    export default {
        props: {
            disabled: {
                type: Boolean,
                default: false,
            },
            value: {
                type: String,
                default: '',
            },
            name: {
                type: String,
                required: true,
            },
            rows: {
                type: Number,
                default: 3,
            },
            label: {
                type: String,
                default: '',
            },
        },

        computed: {
            inputListeners() {
                return {
                    ...this.$listeners,
                    ...{
                        input: event => this.$emit('input', event.target.value),
                    },
                };
            },
        },

        methods: {
            focus() {
                this.$refs.input.focus();
            },
        },
    };
</script>
